





























import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay.vue';

@Component({
  components: {
    Overlay,
  },
})
export default class Drawer extends Vue {
  @Prop({default: ''}) private heading!: string;
  @Prop({default: false}) private showDrawerBoolean!: boolean;
  @Prop({default: 'w-full md:w-2/5'}) private width!: string;
  private mutableShowDrawerBoolean: boolean = false;

  @Watch('showDrawerBoolean')
  public onShowDrawerBooleanChanged(show: boolean) {
    this.mutableShowDrawerBoolean = show;
  }

  @Watch('mutableShowDrawerBoolean')
  public onMutableShowDrawerBooleanChanged(show: boolean) {
    this.$emit('update:showDrawerBoolean', show);
  }
}
